const React = require("react");
const { useNavigate } = require("react-router-dom");
const { useCJDropshipping } = require("../context/CJDropshippingContext");
const { useDropshippingResource } = require("../hooks/useDropshippingResource");
const { PageHeader, ResourceState, Button } = require("../components/ui");
const { filterCategoryTree } = require("../categorySearch");
const h = React.createElement;

// Catégories CJ réelles (arborescence à 3 niveaux normalisée côté serveur,
// voir normalizeCJCategory dans cjDropshipping.service.js). Cliquer une
// catégorie feuille navigue vers le catalogue produits filtré par categoryId
// (déjà supporté par le backend : req.productFilters.categoryId).
const DropshippingCategories = () => {
  const { api, t } = useCJDropshipping();
  const navigate = useNavigate();
  const [openFirst, setOpenFirst] = React.useState(null);
  const [openSecond, setOpenSecond] = React.useState(null);
  const [keyword, setKeyword] = React.useState("");
  const [query, setQuery] = React.useState("");

  const resource = useDropshippingResource(() => api.getCategoriesNormalized(), [api]);
  const categories = resource.data?.categories || [];
  const filteredCategories = React.useMemo(
    () => filterCategoryTree(categories, query),
    [categories, query]
  );
  const isSearching = Boolean(query);

  const goToCategory = (categoryId) => navigate(`/dropshipping/products?categoryId=${encodeURIComponent(categoryId)}`);

  return h(React.Fragment, null,
    h(PageHeader, {
      title: t("h_cj_categories_title", "CJ categories"),
      description: t("h_cj_categories_desc", "Browse CJ Dropshipping's real category tree and jump straight to matching products."),
    }),
    h("form", {
      className: "cjds-toolbar",
      onSubmit: (event) => { event.preventDefault(); setQuery(keyword.trim()); },
    },
      h("input", {
        className: "cjds-input",
        value: keyword,
        onChange: (event) => setKeyword(event.target.value),
        placeholder: t("h_cj_category_search_placeholder", "Search categories by name"),
        "aria-label": t("h_cj_category_search", "Search categories"),
      }),
      h(Button, { type: "submit" }, t("h_cj_search", "Search")),
      h(Button, {
        variant: "secondary",
        disabled: !keyword && !query,
        onClick: () => { setKeyword(""); setQuery(""); },
      }, t("h_cj_reset", "Reset"))
    ),
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !categories.length, onRetry: resource.reload, t },
      isSearching && !filteredCategories.length
        ? h("div", { className: "cjds-state" },
            h("h3", null, t("h_cj_empty_title", "Nothing here yet")),
            h("p", { className: "cjds-muted" }, t("h_cj_category_no_match", "No CJ category matches your search."))
          )
        : h("div", { className: "cjds-categories" }, ...filteredCategories.map((level1) => h("div", { key: level1.id, className: "cjds-category-group" },
            h("button", {
              type: "button",
              className: "cjds-category-toggle",
              onClick: () => setOpenFirst((current) => current === level1.id ? null : level1.id),
            }, level1.name),
            (isSearching || openFirst === level1.id) ? h("div", { className: "cjds-category-children" },
              ...level1.children.map((level2) => h("div", { key: level2.id, className: "cjds-category-group" },
                h("button", {
                  type: "button",
                  className: "cjds-category-toggle cjds-category-toggle--secondary",
                  onClick: () => setOpenSecond((current) => current === level2.id ? null : level2.id),
                }, level2.name),
                (isSearching || openSecond === level2.id) ? h("div", { className: "cjds-category-children" },
                  ...level2.children.map((leaf) => h("button", {
                    key: leaf.id,
                    type: "button",
                    className: "cjds-category-leaf",
                    onClick: () => goToCategory(leaf.id),
                  }, leaf.name))
                ) : null
              ))
            ) : null
          )))
    )
  );
};

module.exports = { DropshippingCategories };
